module.exports = __webpack_public_path__ + "static/media/VisitPITTSBURGH_poster.a355348f.jpg";